export enum Territory {
  POLAND_AND_NEIGHBORS = 'POLAND_AND_NEIGHBORS',
  EUROPEAN = 'EUROPEAN',
  NON_EUROPEAN = 'NON_EUROPEAN',
}
